module.exports = __webpack_public_path__ + "img/img_side_flowerlace.6da58b12.png";